module.exports = __webpack_public_path__ + "img/53a287d.png";